import { Component, Vue } from 'vue-property-decorator'
import  Player from '@/apps/h5/components/player'
import EmptyBox from '@/apps/h5/components/empty-box'

@Component({ components: { Player, EmptyBox }})
export default class VideoDetail extends Vue {
    public source = {
        videoUrl: 'http://17zy-content.oss-cn-beijing.aliyuncs.com/cms-resource%2F05669bc2a5f01135ab8a94f0f66db9b5.mp4',
        poster: '',
        title: '',
        videoName: '',
        progress: 0
    }
}

